<template>
  <Modal
    :title="
      edit
        ? $t('auxiliaryCoolingEquipment.edit')
        : $t('auxiliaryCoolingEquipment.add')
    "
    @ok="save"
    :value="value"
    :okText="
      edit
        ? $t('auxiliaryCoolingEquipment.edit')
        : $t('auxiliaryCoolingEquipment.add')
    "
    @input="$emit('input', $event)"
  >
    <ProjectAuxiliaryCoolingEquipmentSearch
      :label="$t('auxiliaryCoolingEquipment.equipment')"
      v-model="formData.auxiliaryCoolingEquipmentId"
    ></ProjectAuxiliaryCoolingEquipmentSearch>
    <div class="u-margin-top-small">
      <div class="u-margin-bottom-small o-alert o-alert--info">
        {{ $t("auxiliaryCoolingEquipment.info") }}
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Base/Modal.vue";
import Requests from "@/services/Requests";
import ProjectAuxiliaryCoolingEquipmentSearch from "@/components/Searches/AuxiliaryCoolingEquipmentSearch.vue";
export default {
  components: {
    Modal,
    ProjectAuxiliaryCoolingEquipmentSearch,
  },
  props: {
    value: {
      default: false,
    },
    projectId: {
      default: null,
    },
  },
  data() {
    return {
      formData: {
        auxiliaryCoolingEquipmentId: null,
        projectId: this.projectId,
      },
    };
  },
  watch: {
    value(value) {
      if (value) {
        this.checkProps();
      }
    },
  },
  methods: {
    validation() {
      return Object.values(this.formData).every(
        (value) => value !== null && value !== ""
      );
    },
    async save(loading) {
      this.formData.projectId = this.projectId;
      if (!this.validation()) {
        this.$store.dispatch("SET_ACTION_MODAL", {
          status: true,
          message: this.$t("auxiliaryCoolingEquipment.fillAllFields"),
          variant: "danger",
          duration: 2500,
        });
        return;
      }

      loading(true);
      const response = await Requests.ProjectAuxiliaryCoolingEquipment.Create({
        auxiliaryCoolingEquipmentId:
          this.formData.auxiliaryCoolingEquipmentId.id,
        projectId: this.projectId,
      });

      if (response.message === "OK") {
        this.$store.dispatch("SET_ACTION_MODAL", {
          status: true,
          message: this.$t("auxiliaryCoolingEquipment.success"),
          variant: "success",
          duration: 2500,
        });
        this.$emit("refresh");
        this.$emit("input", false);
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          status: true,
          message: this.$t(`message.${response.message}.description`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
  },
};
</script>
